export default __webpack_public_path__ + "static/media/img22.d07f0fd5.jpg";